import { getCookies } from 'component/Helpers/getCookies'

export const setSessionsAndCookies = () => {
	// Create Session UTM
	if (typeof window !== 'undefined') {
		var query = window.location.search
		if (query !== '') {
			var fullQuery = window.location.search.split('?')[1]
			var pairs = fullQuery.split('&')
			let others = []

			pairs.forEach(function (el) {
				if (el.split('=')[0] === 'utm_source') {
					sessionStorage.setItem('aurumUtmSource', el.split('=')[1])
				} else if (el.split('=')[0] === 'utm_medium') {
					sessionStorage.setItem('aurumUtmMedium', el.split('=')[1])
				} else if (el.split('=')[0] === 'utm_campaign') {
					sessionStorage.setItem('aurumUtmCampaign', el.split('=')[1])
				} else if (el.split('=')[0] === 'utm_term') {
					sessionStorage.setItem('aurumUtmTerm', el.split('=')[1])
				} else if (el.split('=')[0] === 'utm_content') {
					sessionStorage.setItem('aurumUtmContent', el.split('=')[1])
				} else {
					others.push(el)
					sessionStorage.setItem('aurumOtherParams', others)
				}
			})
		}
	}

	// Create Session Ref
	var ref = document.referrer
	if (ref !== '') {
		sessionStorage.setItem('aurumRef', ref)
	} else {
		sessionStorage.setItem('aurumRef', 'direct')
	}

	// Create cookie Ref
	var cookieRef = getCookies('aurumRef')
	if (cookieRef === null) {
		if (ref !== '') {
			document.cookie = `aurumRef=${ref}`
		} else {
			document.cookie = `aurumRef=direct`
		}
	}
}
